import React, { useEffect, useRef, useState } from "react";
import DashBorder from "@src/components/UIElements/DashBorder";
import { getGraphCoursePriceDetailsAction, getMoneyBackGuaranteeAction } from "@src/components/Tabs/Overview/store/actions";
import { useSelector , useDispatch } from "react-redux";
import { useRouter } from "@src/lib/router";
import { hitDeeplinkExecutedV2, hitDeeplinkPerformAction } from "@src/utils/hitDeeplink";
import { COMMON_DEEPLINK_ACTIONS } from "@src/utils/constants";
import { directDeepLink } from "@src/common/deepLinks";
import { getIndividualInstallmentService } from "@src/components/Tabs/Overview/store/services";

const MoneyBackGuarantee = ({
      prePurchasePopUpEnabled,
      prePurchaseAddOnAmount,
      addOnOptionId,
      isRemoveButtonEnable,
      data
}) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const [showExitModal, setShowExitModal] = useState(false);
  const [showBenefitModal, setShowBenefitModal] = useState(false);
  const installmentData = useSelector((state)=> state?.overviewReducer?.overViewDetails?.course);

  const listItem = data?.subHeadings || [];
  const benefits = data?.benefits || [];

  function detectMobileOS() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
        return "Android";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    } else {
        return "Other";
    }
  }

  const removeMoneyBackFun = ()=>{
    setShowExitModal(true);
  }

  const confirmExitModal = ()=>{
    dispatch(getMoneyBackGuaranteeAction({
      addOnOptionId:addOnOptionId,
      prePurchasePopUpEnabled:prePurchasePopUpEnabled,
      prePurchaseAddOnAmount:prePurchaseAddOnAmount,
      isRemoveButtonEnable:false,
    }))
    dispatch(
      getGraphCoursePriceDetailsAction({
        courseIds: [`${router.query.courseId}`],
        isBundlingCourse: false,
        avoidCouponsList: true,
        optedAddOn: "remove",
      })
    );
    getIndividualInstallmentService({
      courseId: installmentData?.metaData?.id || '',
      installmentId: installmentData?.installments?.activeInstallmentId || '',
      optedAddOn: 0,
    })
    setShowExitModal(false);
  }

  const addMoneyBack = ()=>{
    dispatch(getMoneyBackGuaranteeAction({
      addOnOptionId:addOnOptionId,
      prePurchasePopUpEnabled:prePurchasePopUpEnabled,
      prePurchaseAddOnAmount:prePurchaseAddOnAmount,
      isRemoveButtonEnable:true,
    }))
    dispatch(
      getGraphCoursePriceDetailsAction({
        courseIds: [`${router.query.courseId}`],
        isBundlingCourse: false,
        avoidCouponsList: true,
        optedAddOn: addOnOptionId,
      })
    );
    getIndividualInstallmentService({
      courseId: installmentData?.metaData?.id || '',
      installmentId: installmentData?.installments?.activeInstallmentId || '',
      optedAddOn: addOnOptionId,
    })
  }

  const benefitModal = ()=>{
      setShowBenefitModal(true);
  }
  const openURL = () => {
    if(detectMobileOS() === 'iOS'){
      hitDeeplinkExecutedV2(
        JSON.stringify({
          screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
          paramOne: data?.tnc,
        }),
        JSON.stringify({
          screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
          paramOne: data?.tnc,
        })
      );
    }else{
      const newDeepLink = {};
      newDeepLink.paramOne = data?.tnc;
      directDeepLink({}, "UTIL_WEBVIEW", false)(newDeepLink);
    }
    };

  return (
    <>
      <div className="MoneyBack">
        {!isRemoveButtonEnable ? (
          <div className="MoneyBackStrip">
            <img
              src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/moneybackstrip2.png"
              alt="img"
            />
          </div>
        ) : null}
        <div className="MoneyBackCard">
          <div
            className="cardContent"
            style={{ background: data?.cardColor || "#fff" }}
          >
            <div className="cardHeader">
              <img src={data?.icon} alt="img" width={32} />
              <h4>{data?.heading}</h4>
            </div>
            <ul className="infoList">
              {listItem.map((data, index) => {
                return <li key={index}> {data}</li>;
              })}
            </ul>
          </div>
          <div className="cardFooter">
            <div
              className={`flexColumn ${addOnOptionId === 4 ? "flexRow" : ""}`}
            >
              {prePurchaseAddOnAmount !== 0 ? (
                <h2>
                  {String(prePurchaseAddOnAmount).replace("+", "").trim() || ""}
                </h2>
              ) : null}
              <h4>
                <img
                  onClick={benefitModal}
                  src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/nfo-grey-icon-img.png"
                  alt="img"
                  width={12}
                />
                View all benefits
              </h4>
            </div>
            {addOnOptionId === 1 ? (
              isRemoveButtonEnable ? (
                <button onClick={removeMoneyBackFun}>Remove</button>
              ) : (
                <button onClick={addMoneyBack}>
                  <img
                    src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/plush-vector-img.png"
                    alt="img"
                    width={12}
                  />
                  Add
                </button>
              )
            ) : null}
          </div>
        </div>
      </div>

      {showExitModal ? (
        <div
          className={
            showExitModal
              ? "ModalWrapper ModalMoneyBack ModalWrapper__Show"
              : "ModalWrapper ModalMoneyBack ModalWrapper__Hide"
          }
        >
          <div className="Backdrop Backdrop__Show"></div>
          <div
            className={
              showExitModal ? "Modal Modal__Show" : "Modal Modal__Hide}"
            }
          >
            <div className="Modal--Close">
              <img
                onClick={() => {
                  setShowExitModal(false);
                }}
                src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/modal-close-circle-img.png"
                alt="close"
                width={80}
              />
            </div>
            <div className="Modal__Body">
              <h4>Are you sure you want to remove the {data?.heading}?</h4>
              <p>
                By removing this, you will no longer be eligible for a refund
                within 15 days of purchase.
              </p>
              <button
                className="Btn-Add-Money"
                onClick={() => setShowExitModal(false)}
              >
                No, Add money back for{" "}
                {String(prePurchaseAddOnAmount).replace("+", "").trim() || ""}{" "}
                only
              </button>
              <button className="Btn-Remove-Money" onClick={confirmExitModal}>
                No, I don’t want the {data?.heading}
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {showBenefitModal ? (
        <div
          className={
            showBenefitModal
              ? "ModalWrapper ModalMoneyBackShowBenefit ModalWrapper__Show"
              : "ModalWrapper ModalMoneyBackShowBenefit ModalWrapper__Hide"
          }
        >
          <div className="Backdrop Backdrop__Show"></div>
          <div
            className={
              showBenefitModal ? "Modal Modal__Show" : "Modal Modal__Hide}"
            }
          >
            <div className="Modal--Close">
              <img
                onClick={() => {
                  setShowBenefitModal(false);
                }}
                src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/modal-close-dark-img.png"
                alt="close"
                width={24}
              />
            </div>
            <div className="Modal__Body">
              <img
                className="benefit-img"
                src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/show-benefit-img.png"
                alt="img"
                width={180}
              />
              <h4>{data?.heading} Activated</h4>
              <ul className="benefit-list">
                {benefits.map((item, index) => {
                  return <li key={index}>{item}</li>;
                })}
              </ul>
            </div>
            <div className="modal-footer">
              <span onClick={openURL}>
                <img
                  src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/info-colored-icon-img.png"
                  width={10}
                  alt="info"
                />
                {"T&C Applied"}
              </span>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
const MemoizedAboutCourse = React.memo(MoneyBackGuarantee);
export default MemoizedAboutCourse;



